<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>

        <v-layout align-center justify-center column>
          <h2 class="heading-3">{{ heading }}</h2>
        </v-layout>

        <v-layout row align-center justify-center>
          <a v-if="facebookSignInURL" class="social-button social-button--facebook" :href="facebookSignInURL" >Login with Facebook</a>
          <a v-if="twitterSignInURL" class="social-button social-button--twitter" :href="twitterSignInURL" >Login with Twitter</a>
          <a v-if="googleSignInURL" class="social-button social-button--google" :href="googleSignInURL">Login with Google</a>
          <a v-if="appleSignInURL && showAppleSignIn" class="social-button social-button--apple" :href="appleSignInURL">Login with Apple</a>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'SocialSignIn',

  props: {
    heading: {
      type: String,
      required: true
    }
  },

  data () {
    
    return {
      facebookSignInURL: `https://${process.env.VUE_APP_AWS_COGNITO_AUTH_SERVER}/oauth2/authorize?response_type=code&client_id=${process.env.VUE_APP_AWS_CLIENT_ID}&redirect_uri=${process.env.VUE_APP_AWS_COGNITO_AUTH_REDIRECT_URI}&identity_provider=Facebook`,
      twitterSignInURL: null,
      googleSignInURL: `https://${process.env.VUE_APP_AWS_COGNITO_AUTH_SERVER}/oauth2/authorize?response_type=code&client_id=${process.env.VUE_APP_AWS_CLIENT_ID}&redirect_uri=${process.env.VUE_APP_AWS_COGNITO_AUTH_REDIRECT_URI}&identity_provider=Google`,
      appleSignInURL: `https://${process.env.VUE_APP_AWS_COGNITO_AUTH_SERVER}/oauth2/authorize?response_type=code&client_id=${process.env.VUE_APP_AWS_CLIENT_ID}&redirect_uri=${process.env.VUE_APP_AWS_COGNITO_AUTH_REDIRECT_URI}&identity_provider=SignInWithApple&scope=aws.cognito.signin.user.admin email openid profile`,
      showAppleSignIn: true
    }
  },
  mounted () {
    if(window.location.href.includes("showAppleSignIn=true")){
      this.showAppleSignIn = true
    }
  },
  methods: {
    authenticate (provider) {
      this.$auth.authenticate(provider).then(function () {
        // Execute application logic after successful social authentication
        console.log('SOCIAL AUTH')
      })
    }
  }
}
</script>

<style scoped>
</style>